import styled, { keyframes, css } from 'styled-components';
import { Card, Button,Col, Steps, Typography, Collapse,Upload, Carousel, Image } from 'antd';
import {MySegmented} from "../../components";
const isMobile = window.innerWidth < 768;

const { Paragraph } = Typography;
const { Step } = Steps;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.9);
  }
`;

export const ButtonContainer = styled.div`
  background-color: white;
  width: ${isMobile ? '38px' : '48px'};
  height: ${isMobile ? '38px' : '48px'};
  border-radius: 50%;
  border: 2px solid rgba(229, 233, 242, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(0, 189, 244, 1);
    & svg {
      color: #fff;
    }
  }
`;

export const PageName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ThemeMobileButton = styled.button`
  background-color: rgba(231, 250, 255, 1);
  color: rgba(0, 141, 210, 1);
  border: none;
  padding: 10px 20px;
  border-radius: 40px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  width: 108px;
  height: ${isMobile ? '50px' : 'auto'};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ThemeButton = styled(Button)`
  
  .ant-btn-default.ant-btn-color-default.ant-btn-variant-outlined {
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
      color: none !important;
      border-none: inherit !important;
    }
  }
  
  .ant-btn-color-default {
    box-shadow: none !important;
  }
`;

export const StyledImageWrapper = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  .ant-image {
    height: 100%;
    width: 100%;
  }

  .ant-image-img {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover;
    border-radius: 8px;
  }
`;

export const PlayButtonContainer = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    & svg {
      color: #fff;
    }
  }
`;